<!-- /src/views/Course.vue -->
<template>
  <LayoutFullWidth class="layout--course layout--header--has-interactions">
    <template v-if="post" v-slot:header>
      <h1
        class="page-header"
        v-html="post.title.rendered"
      ></h1>
      <PostInteractions :post="post" />
    </template>
    <template v-slot:content>
      <Loader v-if="isLoading && post" color="gray" />
      <div class="course__body-content">
        <div class="course__section"
          v-for="(section, sectionIndex) in sections"
          :key="`path-session-list_${sectionIndex}`"
        >
          <CourseSessionList
            :id="post.id"
            :type="post.type"
            :sectionKey="section.sectionKey"
            :section="section"
            :nextSection="section.nextSection"
            :courseInteractions="currentInteraction"
            @courseSectionCompleted="completedSection"
          />
        </div>
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
import LayoutFullWidth from '@/components/layouts/FullWidth'
import CourseSidebar from '@/components/Course/Sidebar'
import CourseSessionList from '@/components/Course/SessionList'
import PostInteractions from '@/components/common/PostInteractions'
import postMixin from '@/mixins/postMixin'
import Loader from '../components/common/Loaders/Loader'
import { checkNested } from '@/components/common/utils/helpers.js'
import _every from 'lodash/every'
import _isEmpty from 'lodash/isEmpty'
import _isUndefined from 'lodash/isUndefined'

export default {
  
  data() {
    return {
      isLoading: true,
      sectionInteractions: [],
      courseIsComplete: false,
      completeLoading: false,
      sectionCount: 0,
    }
  },
  mixins: [postMixin],
  computed: {
    post() {
      const output = this.$store.getters['posts/findItemByProp'](
        'courses',
        this.$route.params.slug,
        'slug',
      )

      if (output) {
        this.$store.dispatch('updatePageTitle', 'Course: ' + output.title.rendered)
      }

      return output;
    },

    sections: {
      get() {
        let collection_lists = []
        if (checkNested(this, 'post', 'acf', 'section_collection')) {
          this.isLoading = false
          const { section_collection } = this.post.acf
          if (checkNested(this,'post', 'collection_lists')) {
            collection_lists = this.post.collection_lists[0]
          }
          Object.keys(section_collection).forEach(key => {
            section_collection[key]['child_objects'] = !_isUndefined(collection_lists[key][0]) ? collection_lists[key] : []

            section_collection[key]['sectionKey'] = 'pathSection'+key
            const nextKey = parseInt(key) + 1
            if (!_isUndefined(section_collection[nextKey])) {
              section_collection[key]['nextSection'] = section_collection[nextKey]
            }
          })
          this.sectionCount = section_collection.length
          return section_collection
        }
      },
      set(value) {
        return value
      },
    },
  },

  methods: {

    completedSection(emitted) {
      const { sections, setCompleted } = this
      let update = []
      Object.keys(sections).forEach(key => {
        if (typeof (sections[key].sectionKey) != undefined && sections[key].sectionKey == emitted.sectionKey) {
          sections[key]['sectionCompleted'] = emitted.sectionCompleted
          update.push(true)
        } else {
          update.push(false)
        }
      })
      if (_every(update, i => i == true)) {setCompleted()}
    },

    setCompleted() {
      const { sections } = this
      const completes = sections.map(section => {
          return (typeof section['sectionCompleted'] != undefined) ? section['sectionCompleted'] : false
      })
      
      completes.sort((a, b) => {
        return new Date(b).getTime() - new Date(a).getTime()
      })
      
      if (this.sectionCount == completes.length) {
        this.courseIsComplete = completes[0]
        if (_isUndefined(this.currentInteraction.dateCompleted)) this.markComplete(this.courseIsComplete)
      }

    },

    startNextSession(section) {
      console.log(section)
    },
  },


  components: {
    LayoutFullWidth,
    CourseSidebar,
    CourseSessionList,
    PostInteractions,
    Loader,
    Loader
},

  mounted() {
    this.visitedPost()
  },

  beforeMount() {
    // this.$store.dispatch('posts/getPost', { slug: this.$route.params.slug, title: this.$route.meta.title })
  },
}
</script>

<style scoped>
.layout--course {
  &.layout__content__columns {
    grid-template-columns: 25rem auto;
  }

  &.layout__content__columns__rightInterior {
    padding: 0;
  }

  .course {
    &__content {
      border-radius: var(--borderRadiusSmall);
      overflow: hidden;

      @media (--tablet) {
        border-radius: 0;
      }
    }

    &__section {
      margin-bottom: 2rem;
      &:last-child {
        margin-bottom: 0;
      }
    }

    &__action-bar {
      background-color: var(--gray);
      display: flex;
      margin: 0;
      padding: 0.75rem var(--itemSpacing);
      justify-content: flex-end;
      list-style: none;
      border-bottom-left-radius: var(--borderRadiusSmall);
      border-bottom-right-radius: var(--borderRadiusSmall);
      font-size: 0.7em;

      @media (--tablet) {
        border-bottom-left-radius: 0;
      }

      &__item {
        margin: 0;
        padding: 0;
        position: relative;

        .button {
          margin-right: 1.5rem;
        }

        &:first-child {
          flex: 1;
        }

        &:last-child {
          .button {
            margin-right: 0;
          }
        }

        &--active {
          .session__action-bar__item__dropdown {
            opacity: 1;
          }
        }

        &__dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          opacity: 0;
          background-color: white;
          /* font-size: 0.7rem; */
          transform: translateY(10px);
          border-radius: var(--borderRadiusSmall);
          overflow: hidden;

          &__item {
            padding: 0.5rem 1rem;
            border-bottom: 1px solid var(--lightGray);
            cursor: pointer;

            &:hover {
              background-color: var(--lightGray);
            }

            &Title {
              font-weight: var(--fontWeightBold);
            }

            &Time {
              font-style: italic;
            }
          }
        }
      }
    }

    &__body-content {
      margin: 0 2rem;

      a {
        text-decoration: underline;
      }

      ol {
        list-style: decimal;
        margin-left: 1rem;

        li {
          ol {
            list-style: lower-alpha;
            margin-left: 1.5rem;
          }
        }
      }

      ul {
        margin-left: 1rem;
        list-style-type: square;
      }

      blockquote {
        border-left: 5px solid var(--gray);
        padding-left: 1rem;
      }
    }

    &__attachments {
      &__title {
        color: var(--brandPrimary);
        font-size: 1.25rem;
        margin: 1rem 0 0.5rem;
      }
    }
  }
}
</style>
